import { widgetState } from './index'

export const isTilesLayout = (): boolean => {
  return widgetState.customizations.selectionType === 'tiles-only'
}
